import { Controller } from 'stimulus';

class CollapseController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onTriggerClick(event) {
    const target = event.currentTarget;
    const collapseTarget = document.getElementById(target.getAttribute('aria-controls'));
    const isExpanded = target.getAttribute('aria-expanded') === 'true';

    target.setAttribute('aria-expanded', !isExpanded);
    collapseTarget[!isExpanded ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');

    this.element.classList[!isExpanded ? 'add' : 'remove']('is-expanded');
  }
}

CollapseController.targets = [
  //
];

export default CollapseController;
